<template>
  <div id="breadcrumb" v-if="$route.path != '/'">
    <div class="container breadcrumb flex align_items_ctr">
      <!-- <img class="location_icon" src="../../assets/imgs/location.png" alt="" /> -->
      <!-- <span>您的位置：</span> -->
      <span>
        <span
          v-for="(item, index) in pathList"
          :key="index"
          @click="goPageClick(item.path, index)"
          :class="{ breadcrumb_txt: index != pathList.length - 1 }"
        >
          {{ item.title }}
          <span v-if="index != pathList.length - 1" class="s_divi">/</span>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import { DETAIL_DATASETCODE_MAP } from "@/utils/staticData"
export default {
  name: "breadcrumb",
  data() {
    return {
      pathList: [],
    };
  },
  created() {
    this.setBreadcrumb();
  },
  methods: {
    goPageClick(path, index) {
      if (index < this.pathList.length - 1) {
        this.$router.push(path);
      }
    },
    setBreadcrumb() {
      this.pathList = [];
      let currentRouteObj = this.$route;
      let currentroute = {
        path: currentRouteObj.path,
        title: currentRouteObj.meta.title,
      };
      let indexRoute = { path: "/", title: "首页" };
      let breadList =
        (currentRouteObj.meta && currentRouteObj.meta.bread) || [];
      this.pathList = [indexRoute, ...breadList, currentroute];
      /* 设置列表页 */
      if (currentRouteObj.path == "/list") {
        const { moduleCode } = this.$route.query;

        let listMap = {
          'RDPI_search_all':'通检',
          'RDPI_search_person':'军政人事',
          'RDPI_search_jywx':'文献',
          'RDPI_search_qb_dynamics':'情报动态',
          'RDPI_search_org':'组织单位',
          'RDPI_search_battle_case':'战争战例',
          'RDPI_search_weapon': '武器装备',
          'RDPI_search_media':'影像资料'
        }
        this.pathList = [
          indexRoute,
          { path: '', title: (listMap?.[moduleCode]||'') + "列表" },
        ];
      }
      /* 设置详情页 */
      if (currentRouteObj.path == "/detail") {
        const { data_type,moduleCode } = this.$route.query;
        let obj = DETAIL_DATASETCODE_MAP[data_type] || {
          listPath: "",
          title: "",
          listTitle:''
        };
        /* 处理媒体详情对应列表 */
        let mediaModuleCodeMap = {
          RDPI_detail_image:'图片',
          RDPI_detail_video:'视频'
        }
        let mediaTitle = mediaModuleCodeMap[moduleCode]
        this.pathList = [
          indexRoute,
          {
            path: obj.listPath+(mediaTitle?`&mediaType=${mediaTitle == '图片'?'1':'2'}`:''),
            title: obj.listTitle + "列表",
          },
          { path: obj.path, title:(mediaTitle ||  obj.title) + "详情" },
        ];
      }
    },
  },
  watch: {
    $route() {
      this.setBreadcrumb();
    },
  },
};
</script>

<style lang="less" scoped>
#breadcrumb {
  // padding-top: 10px;
  height: 40px;
  line-height: 40px;
  color: #7C8191;
  background-color:rgba(30,60,99,0.05);
  font-size: 14px;

  .breadCrumb_icon {
    display: inline-block;
    margin-right: 8px;
  }
  .s_divi{
    margin:0 8px;
  }
}

.breadcrumb_txt {
  &:hover {
    color: #1D2541;
    cursor: pointer;
  }
}

.location_icon {
  // width: 10px;
  // height: 14px;
  margin-right: 9px;
}
</style>